import { ManageMeI } from "@/api/routes/manage";
import Router from "@/helpers/router";
import { isManageLga, isManagePodLead } from "@/lib/manage/roles";

/**
 * Where a role holder lands when the applicant gate would otherwise send them
 * away (C-14, C14-F1-D31/D32). F1 owns this file; F3 edits only
 * `firstManagePage` when its block pages land.
 */

export const isManagePath = (pathname: string): boolean =>
  pathname === "/manage" || pathname.startsWith("/manage/");

/**
 * The first manage page the user can open, or null for a caller without a
 * role: then the gate redirects as it always did.
 */
export const firstManagePage = (
  me: ManageMeI | null | undefined
): string | null => {
  if (!me) {
    return null;
  }

  if (me.is_admin) {
    return Router.manageAdmin();
  }

  // C14-F3-D54: LGAs and Pod Leads land on their Calendar.
  if (isManageLga(me) || isManagePodLead(me)) {
    return Router.manageCalendar();
  }

  return null;
};
